export enum OverlayBackground {
  transparent,
  color
}

export type OverlayType = OverlayBackground | null;
